import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { DialogData } from 'src/app/core/models/dialogs.model';

@Component({
  selector: 'app-dialog-component',
  template: `
    <h2 mat-dialog-title *ngIf="data['title']">
      <fa-icon *ngIf="isWarning" [icon]="warningIcon" class="warning-icon"></fa-icon>{{ data['title'] }}
    </h2>

    <mat-dialog-content [innerHTML]="message"></mat-dialog-content>

    <mat-dialog-actions>
      <button mat-button mat-dialog-close *ngIf="data.buttons.cancel">
        {{ data['buttons']['cancel']['text'] | titlecase }}
      </button>
      <button mat-button [mat-dialog-close]="true" *ngIf="data.buttons.confirm">
        {{ data['buttons']['confirm']['text'] | titlecase }}
      </button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
  message = '';

  warningIcon: IconDefinition = faExclamationTriangle;
  isWarning = false;

  constructor(public dialogRef: MatDialogRef<DialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.isWarning = data['isWarning'] ? data['isWarning'] : false;
    if (!data['message'].startsWith('<')) {
      this.message = '<p>' + data['message'] + '</p>';
    } else {
      this.message = data['message'];
    }
  }

  clicked(evt: any) {
    this.dialogRef.close(true);
  }
}
